<template>
    <Content :class="[disabledColor && 'disabled']">
        <template v-if="color.cod_exa2 && color.type == 'COLOR'">
            <span class="color-group">
                <div
                    class="color-group-left"
                    :style="`background-color: ${color.cod_exa};`"
                ></div>
                <div
                    class="color-group-right"
                    :style="`background-color: ${color.cod_exa2};`"
                ></div>
            </span>
        </template>
        <template v-if="!color.cod_exa2 && color.type == 'COLOR'">
            <span
                class="simple-color"
                :style="`background-color: ${color.cod_exa};`"
            ></span>
        </template>
        <template v-if="color.type == 'ESTAMPA'">
            <span class="color-picture">
                <img
                    :src="$pathFilesSystem + '/' + color.path_image"
                    loading="lazy"
                />
            </span>
        </template>
    </Content>
</template>

<script>
import { Content } from "./style";

export default {
    name: "ProductGridColor",
    props: {
        color: {
            required: true
        },
        disabledColor: {
            default: false
        }
    },
    components: {
        Content
    }
};
</script>
